import PropTypes from "prop-types";

export default function BadgeIA({ label = "IA", className = "" }) {
    return (
        <div
            className={`inline-flex items-center rounded-[4px] border-[1.5px] border-[#3FCAD1] bg-[#D6F7F7] ${className}`}
            style={{
                width: "49px",
                height: "24px",
                paddingLeft: "8px",
                paddingRight: "8px",
            }}
        >
            {/* Caja invisible del ícono (16x16) */}
            <div className="flex h-4 w-4 items-center justify-center">
                <span
                    className="material-symbols-outlined"
                    style={{
                        fontSize: "12.67px",
                        color: "#235D67",
                        lineHeight: 1,
                    }}
                >
                    wand_stars
                </span>
            </div>

            {/* Separación */}
            <div className="w-[2px]" />

            {/* Caja invisible del texto (13x15) */}
            <div className="flex h-[15px] w-[13px] items-center justify-center">
                <span
                    style={{
                        color: "#262626",
                        fontFamily: "Encode Sans, sans-serif",
                        fontSize: "12px",
                        fontWeight: 600,
                        letterSpacing: "0.25px",
                        lineHeight: "15px",
                    }}
                >
                    {label}
                </span>
            </div>
        </div>
    );
}

BadgeIA.propTypes = {
    label: PropTypes.string,
    className: PropTypes.string,
};